import { createAsyncThunk } from "@reduxjs/toolkit";
import { pricingAPI } from "services/swagger-api";

// Thunk pour charger la liste des tunnels disponibles
export const fetchFunnels = createAsyncThunk(
  'tunnel/fetchFunnels',
  async (riskId: string, { rejectWithValue }) => {
    try {
      const result = await pricingAPI.getFunnelsByRiskId({ risqueAssureId: riskId });
      return { ...result, riskId };
    } catch (error) {
      return rejectWithValue('Erreur lors du chargement des tunnels pour devis');
    }
  }
);
